import React from "react";
import Icons from "components/icons";
import { Localize } from "components/service";
import {
    getStaffAttendanceStatusIconKey,
} from "../helpers/staff-attendance-session-helper";


const statusLabels = {
    in_progress: "STAFF_MANAGEMENT.AttendanceStatus_InProgress",
    failed_checkout: "STAFF_MANAGEMENT.AttendanceStatus_FailedCheckout",
    missed_checkout: "STAFF_MANAGEMENT.AttendanceStatus_MissedCheckout",
};

const statusIcons = {
    in_progress: Icons.StaffInProcess,
    clock: Icons.StaffClock,
    failed_checkout: Icons.StaffAttention,
    missed_checkout: Icons.StaffClock,
};

const StaffAttendanceStatusField = ({ status, warningCodes }) => {
    const label = statusLabels[ status ];
    const StatusIcon = statusIcons[ getStaffAttendanceStatusIconKey(status, warningCodes) ];

    if (!label)
    {
        return <>&mdash;</>;
    }

    return (
        <span className={ `staff-attendance-status staff-attendance-status--${ status.replace(/_/g, "-") }` }>
            { StatusIcon && <StatusIcon aria-hidden="true" /> }
            <Localize>{ label }</Localize>
        </span>
    );
};

export default StaffAttendanceStatusField;
